import React from 'react'
import { LabFlaskIcon } from 'src/designSystem/icons'
import IndicatorChip from 'src/participantsHome/ParticipantListItem/IndicatorChip'

type Props = {
  expanded?: boolean
}

const LabResultsIndicator = ({ expanded = false }: Props) => (
  <IndicatorChip
    tooltip="Lab results returned"
    label={expanded ? 'Lab results' : undefined}
    testId="lab-results-indicator"
  >
    <LabFlaskIcon />
  </IndicatorChip>
)

export default LabResultsIndicator
